import reduxApi, {transformers} from 'redux-api';
import customFetch from 'api/axios';
import CONFIG from 'base/constants/config';

const limit = 50;
const order = 'createdAt DESC';

// Example
const rest = reduxApi({
  get: {
    url: 'fairs/:id',
    options:(url, params, getState) => {
      return {
        method: "GET",
        headers: {},
        params: params
      };
    }
  },
  list: {
    url: `fairs`,
    options:(url, params, getState) => {
      return {
        method: "GET",
        headers: {},
        data: params
      };
    }
  },
  add: {
    url: 'fairs',
    options:(url, data, getState) => {
      return {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: data
      };
    }
  },
  addProducts : {
    url: 'fairs/:id/addProducts',
    options:(url, data, getState) => {
      return {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: data
      };
    }
  },
  acceptBusiness: {
    url: 'fairs/:id/approveBusiness',
    options:(url, data, getState) => {
      return {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: data
      };
    }
  },
  update: {
    url: 'fairs/:id',
    options:(url, data, getState) => {
      return {
        method: "PATCH",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data: data
      };
    }
  },
  delete: {
    url: 'fairs/:id',
    options: {
      method: "DELETE",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  },
  upload: {
    url: 'containers/fairs/upload',
    options: {
      method: "POST"
    }
  },

  // lấy danh mục của hội chợ
  getCategory: {
    url: '/fairs/:id/categories',
    options: (url, data, getState) => {
      return {
        method: "GET",
        headers: {},
        data
      }
    }
  },
  //danh sách danh mục theo category
  getBusinessesByCategory: {
    url: '/businesses/search',
    options: (url, data, getState) => {
      return {
        method: "GET",
        headers: {},
        data
      }
    }
  },
  //danh sách danh mục theo category
  addBusiness: {
    url: '/fairs/:id/inviteBusinesses',
    options: (url, data, getState) => {
      return {
        method: "POST"
      }
    }
  },

  getDataCategoryOfBusiness: {
    url: '/businesses/:id/productCategories',
    options: (url, data, getState) => {
      return {
        method: "GET"
      }
    }
  },
  addNewProducts: {
    url: '/fairs/:id/addNewProducts',
    options:(url, data, getState) => {
      return {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      };
    }
  }
})
.use('fetch', customFetch)
.use("rootUrl", CONFIG.API_URL);

export default rest;



// WEBPACK FOOTER //
// ./api/fairs.js